/** Anything that can be read like URLSearchParams, including Next's ReadonlyURLSearchParams. */
export interface ReadableSearchParams {
    get: (key: string) => string | null
}

/** Accepts both a params object and a raw query string, with or without a leading question mark. */
export const toSearchParams = (source: ReadableSearchParams | string): ReadableSearchParams =>
    typeof source === 'string' ? new URLSearchParams(source.startsWith('?') ? source.slice(1) : source) : source

/**
 * Returns the path with the given change applied to its query string. Works with relative paths,
 * keeps any params the caller does not touch intact and preserves the hash fragment. Shared by the
 * helpers that own a single query param (pagination, sorting) so they can be combined in one URL.
 */
export const updateQueryParamsInPath = (path: string, applyParams: (params: URLSearchParams) => void): string => {
    if (!path || typeof path !== 'string') {
        return path
    }

    const [pathWithoutHash, ...hashParts] = path.split('#')
    const hash = hashParts.length ? `#${hashParts.join('#')}` : ''
    const [pathname, ...queryParts] = pathWithoutHash.split('?')
    const params = new URLSearchParams(queryParts.join('?'))

    applyParams(params)

    const query = params.toString()
    return query ? `${pathname}?${query}${hash}` : `${pathname}${hash}`
}
